import { ENDPOINTS } from "utils/endpoints";
import {
  DELETE_API_CALL,
  GET_API_CALL,
  PATCH_API_CALL,
  POST_API_CALL,
} from "utils/services";
import { APIResponseModal, ReducersModal } from "utils/modals";
import { createQueryParams } from "utils/constants";
import { CAR_COMPANY_REDUCER } from "store/actionTypes";
import {
  mapCarCompanyListItem,
  mapCarTypeListItem,
  mapPaginatedResult,
  mapVehicleListItem,
} from "utils/apiMappers";
import SHOW_TOAST from "utils/showToast";

/**
 * GET /api/v1/shinology/brands/vehicleBrands?page&limit&search
 */
export const getCarCompanyList = (callback: any, params: any = {}) => {
  return (dispatch: Function, getState: Function) => {
    const store: ReducersModal = getState();
    const carCompanies = store.CarCompanyReducer;
    const {
      carCompanies: {
        pagination: { limit, page },
        result: originalList,
        search: storedSearch,
      },
    } = carCompanies;
    const search = `${params.search ?? storedSearch ?? ""}`.trim();

    dispatch({
      type: CAR_COMPANY_REDUCER,
      payload: {
        carCompanies: {
          ...carCompanies.carCompanies,
          isLoading: true,
          search,
        },
      },
    });

    const query = createQueryParams({
      page,
      limit,
      ...(search ? { search: encodeURIComponent(search) } : {}),
    });
        GET_API_CALL(
      ENDPOINTS.COMPANIES.COMPANIESLIST + "?",
      query,
      (response: APIResponseModal) => {
        if (response.isSuccess && response.data) {
          const dataToSave = mapPaginatedResult(
            response.data,
            mapCarCompanyListItem
          );
                    if (page > 1) {
            dataToSave.result = [...originalList, ...dataToSave.result];
          }
          dispatch({
            type: CAR_COMPANY_REDUCER,
            payload: {
              carCompanies: {
                ...carCompanies.carCompanies,
                ...dataToSave,
                search,
                isLoading: false,
              },
            },
          });
          callback(dataToSave);
        } else {
          dispatch({
            type: CAR_COMPANY_REDUCER,
            payload: {
              carCompanies: {
                ...carCompanies.carCompanies,
                search,
                isLoading: false,
              },
            },
          });
          callback({ result: [] });
        }
      }
    );
  };
};

/**
 * GET /api/v1/shinology/car/carType?page&limit&search
 */
export const getCarTypeList = (params: any) => {
  return () => {
    GET_API_CALL(
      ENDPOINTS.UTILITY.CARS_TYPE_LISTING + "?",
      createQueryParams({ page: 1, limit: 100, ...(params?.data || {}) }),
      (response: APIResponseModal) => {
        if (response.isSuccess && response.data) {
          const { result } = mapPaginatedResult(
            response.data,
            mapCarTypeListItem
          );
                    params.callback(result);
        } else {
          params.callback([]);
        }
      }
    );
  };
};

export const addNewCompany = (params: any) => {
  return (dispatch: Function, getState: Function) => {
    POST_API_CALL(
      ENDPOINTS.COMPANIES.ADD_NEW_COMPANY,
      params.data,
      (response: APIResponseModal) => {
        if (response.isSuccess && response.data) {
          dispatch(getCarCompanyList(params.callback));
          params.callback(response?.data?.result);
        } else {
          params.callback();
        }
      }
    );
  };
};

/**
 * PATCH /api/v1/shinology/brands/update-vehicle-brand/{id}
 * id comes from GET /api/v1/shinology/brands/vehicleBrands
 * payload: { name, logo? } — id is path-only, not in body
 */
export const updateCompany = (params: any) => {
  return (dispatch: Function) => {
    const { id, ...payload } = params.data || {};
    const url = `${ENDPOINTS.COMPANIES.UPDATE_COMPANY}/${id}`;
        PATCH_API_CALL(url, payload, (response: APIResponseModal) => {
            if (response.isSuccess && response.data) {
        dispatch(getCarCompanyList(params.callback));
        params.callback(response?.data?.result);
      } else {
        params.callback();
      }
    });
  };
};

export const deleteCompany = (params: any) => {
  return (dispatch: Function, getState: Function) => {
    DELETE_API_CALL(
      ENDPOINTS.COMPANIES.DELETE_COMPANY + "/" + params.data.id,
      (response: APIResponseModal) => {
        if (response.isSuccess) {
          dispatch(getCarCompanyList(params.callback));
          params.callback(response?.data?.result);
        } else {
          params.callback();
        }
      }
    );
  };
};

/**
 * POST /api/v1/shinology/car/add-user-vehicle
 * payload: { vehicleId, vehicleBrandId, vehicleType?, userId }
 */
export const addVichleToUser = (params: any) => {
  return () => {
    POST_API_CALL(
      ENDPOINTS.VEHICLE.ADD_VEHICLE_TO_USER,
      params.data,
      (response: APIResponseModal) => {
        if (response.isSuccess && response.data) {
          if (response.data.message) {
            SHOW_TOAST(response.data.message, "success");
          }
          params.callback(response?.data);
        } else {
          params.callback();
        }
      }
    );
  };
};

/**
 * GET /api/v1/shinology/car/get-user-vehicle?page&userId&vehicleType
 * Preserves user-vehicle `_id` as userVehicleId for order creation.
 */
export const getUsersVechiles = (params: any) => {
  return (dispatch: Function, getState: Function) => {
    GET_API_CALL(
      ENDPOINTS.USERS.GET_USER_VEHICLE + "?",
      createQueryParams(params.data || {}),
      (response: APIResponseModal) => {
        if (response.isSuccess && response.data) {
          const { result } = mapPaginatedResult(
            response.data,
            (vehicle: any) => {
              const userVehicleId =
                vehicle?._id ||
                vehicle?.userVehicleId ||
                vehicle?.id ||
                "";
              const mapped = mapVehicleListItem(vehicle);
              return {
                ...mapped,
                id: userVehicleId,
                _id: userVehicleId,
                userVehicleId,
                registrationNumber:
                  vehicle?.registrationNumber ||
                  vehicle?.vehicleRegistrationNumber ||
                  "",
                vehicleRegistrationNumber:
                  vehicle?.vehicleRegistrationNumber ||
                  vehicle?.registrationNumber ||
                  "",
              };
            }
          );
                    params.callback(result);
        } else {
          params.callback([]);
        }
      }
    );
  };
};

/**
 * DELETE /api/v1/shinology/car/delete-user-vehicle/{userVehicleId}?userId=
 */
export const delelteVichleToUser = (params: any) => {
  return () => {
    const userVehicleId = params.data.id;
    const userId = params.data.userId;
    const url = userId
      ? `${ENDPOINTS.VEHICLE.DELETE_VEHICLE_TO_USER}${userVehicleId}?userId=${userId}`
      : `${ENDPOINTS.VEHICLE.DELETE_VEHICLE_TO_USER}${userVehicleId}`;
    DELETE_API_CALL(url, (response: APIResponseModal) => {
      if (response.isSuccess) {
        if (response.data?.message) {
          SHOW_TOAST(response.data.message, "success");
        }
        params.callback(response?.data);
      } else {
        params.callback();
      }
    });
  };
};
